import { Pipe, PipeTransform } from "@angular/core";
import { LocationType } from "planning-portal-library/src/lib/core/domain/enums/location-types";

@Pipe({
  name: "enumLocationTypeToString",
  standalone: true
})
export class EnumLocationTypeToString implements PipeTransform {
  transform(value: any, enumType: any): string {
   const x= Object.keys(enumType)[Object.values(enumType).indexOf(value)];

    return x;
  }

}